import React, { useEffect, useState} from "react";

const ReviewPage = props => {
    return(
        <div>
            <h5>{props.createForm.name.value}</h5>
            <p style={{marginBottom:'0'}}>{props.createForm.unitType.value.text}</p>

            <br/>
            
            <p style={{marginBottom:'0'}}>Measured parameter: <strong>
                {props.quantities.options.find(obj => obj.id == props.quantities.value).quantity} ({props.units.options.find(obj => obj.id == props.units.value).unit_symbol})
                </strong>
            </p>

            <br/>

            <h5>{props.createForm.supplier.value}</h5>
            <>
            {
                ['AlertLabs', 'Edgecom'].includes(props.createForm.supplier.value) &&
                <>
                    <p style={{marginBottom:'0'}}>Registered device name: <strong>{props.deviceName}</strong></p>
                    <p style={{marginBottom:'0'}}>Device location name: <strong>{props.deviceLocationName}</strong></p>
                </>
            }
            {
                props.createForm.supplier.value === 'AlertLabs' && 
                <p style={{marginBottom:'0'}}>Account: <strong>{props.alertLabsAccount}</strong></p>
            }
            {
                props.createForm.supplier.value === 'Milesight' && 
                <>
                    <p>Notification recipients: <strong>{props.notificationRecipients?.map(user => `${user.first_name} ${user.last_name} (${user.email})`).join(', ')}</strong></p>
                    <p style={{marginBottom:'0'}}>DevEUI: <strong>{props.deveui}</strong></p>
                    <p style={{marginBottom:'0'}}>Send alert when battery reaches <strong>{props.batteryThreshold}%</strong></p>
                    <p style={{marginBottom:'0'}}>Send alert when RSSI falls to <strong>{props.rssiThreshold}</strong> or less</p>
                    <p style={{marginBottom:'0'}}>Send alert when SNR falls to <strong>{props.snrThreshold}</strong> or less</p>
                </>
            }
            {props.createForm.supplier.value === 'Offline' &&
                <p style={{marginBottom:'0'}}>Device type: <strong>{props.deviceType}</strong></p>}

            <br/>

            {props.createForm.supplier.value !== 'Offline' && <>
                <p style={{marginBottom:'0'}}>Sensor resolution: <strong>{props.intervalMinutes} minutes</strong></p>
                <p>Expected reporting interval: <strong>{props.gapMinutes} minutes</strong></p>
            </>}
            {props.showSteam && <>
                <h5>Saturated steam conditions</h5>
                <p>Operating pressure: <strong>{props.steamPressure} psig</strong></p>
                <p>Operating temperature: <strong>{props.steamTemperature} °F</strong></p>
            </>}
            {props.showQTCurrent && <>
                <br/>
                <h5>Current measurement details</h5>
                <p style={{marginBottom:'0'}}>Voltage: <strong>{props.voltage} V</strong></p>
                <p style={{marginBottom:'0'}}>Assumed power factor: <strong>{props.powerFactor}</strong></p>
                <p style={{marginBottom:'0'}}>Phase type: <strong>{props.phaseType}</strong></p>
                {props.createForm.supplier.value === 'Milesight' && <p style={{marginBottom:'0'}}>CT channels: <strong>{props.channelCount}</strong></p>}
                <p>VFD: <strong>{props.hasVfd ? 'Yes' : 'No'}</strong></p>
            </>}
            </>
        </div>
    );
}

export default ReviewPage;
